<template>
  <v-card
    class="d-flex align-center px-5 py-3"
    color="var(--kaki)"
    elevation="0"
  >
    <div
      class="action --text-kaki-fonce"
    >
      {{ message }}
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'BaseMessageV2',
  props: {
    message: {
      type: String,
      default: ''
    }
  },
}
</script>

<style scoped>
</style>
